import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 items-stretch gap-6 w-full max-w-5xl" }
const _hoisted_2 = { class: "flex items-start gap-4 text-left" }
const _hoisted_3 = { class: "inline-flex items-center justify-center rounded-lg bg-primary/10 text-primary size-10" }
const _hoisted_4 = { class: "flex items-start gap-4 text-left" }
const _hoisted_5 = { class: "inline-flex items-center justify-center rounded-lg bg-primary/10 text-primary size-10" }
const _hoisted_6 = { class: "flex items-start gap-4 text-left" }
const _hoisted_7 = { class: "inline-flex items-center justify-center rounded-lg bg-primary/10 text-primary size-10" }
const _hoisted_8 = { class: "relative flex flex-col lg:flex-row items-center gap-8 p-8 lg:p-10" }
const _hoisted_9 = { class: "flex-1 text-center lg:text-left" }
const _hoisted_10 = { class: "inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 dark:bg-emerald-950/30 border border-emerald-200 dark:border-emerald-800 mb-4" }
const _hoisted_11 = { class: "flex flex-wrap justify-center lg:justify-start gap-4" }
const _hoisted_12 = { class: "flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_13 = { class: "flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_14 = { class: "flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_15 = { class: "flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_16 = { class: "flex flex-col items-center gap-4 min-w-[240px]" }
const _hoisted_17 = { class: "mt-0" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = { class: "flex items-center gap-2 p-3 bg-pink-50 dark:bg-pink-950/20" }
const _hoisted_20 = { class: "font-semibold text-pink-700 dark:text-pink-300" }
const _hoisted_21 = { class: "flex items-center gap-2 p-3 bg-blue-50 dark:bg-blue-950/20" }
const _hoisted_22 = { class: "font-semibold text-blue-700 dark:text-blue-300" }
const _hoisted_23 = { class: "flex items-center gap-2 p-3 bg-purple-50 dark:bg-purple-950/20" }
const _hoisted_24 = { class: "font-semibold text-purple-700 dark:text-purple-300" }
const _hoisted_25 = { class: "flex items-center gap-2" }
const _hoisted_26 = { class: "font-semibold text-green-700" }
const _hoisted_27 = { class: "flex flex-1 items-center justify-between p-3 bg-purple-50 dark:bg-purple-950/20" }
const _hoisted_28 = { class: "flex items-center gap-2" }
const _hoisted_29 = { class: "font-semibold text-purple-700 dark:text-purple-300" }
const _hoisted_30 = { class: "mt-16" }
const _hoisted_31 = { class: "flex flex-col md:flex-row gap-8 w-full mt-8" }
const _hoisted_32 = { class: "mt-16" }
const _hoisted_33 = { class: "flex flex-col md:flex-row gap-8 w-full mt-8" }
const _hoisted_34 = { class: "mt-16" }
const _hoisted_35 = { class: "p-6" }
const _hoisted_36 = { class: "mb-4" }
const _hoisted_37 = { class: "inline-flex items-center justify-center w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full mb-4" }

import { Motion } from "motion-v";


export default /*@__PURE__*/_defineComponent({
  __name: 'pricing',
  setup(__props) {

defineOgImage("MainOg", {
  title: "Pricing - Family Assessment Centre Management Software",
  description:
    "Smart pricing based on active residents, not beds. Perfect for family assessment centres tracking multiple family members per unit.",
  theme: "#f5f5f5",
  colorMode: "light",
});

useSeoMeta({
  title: "Pricing - Family Assessment Centre Management Software | FamilyAxis",
  description:
    "Smart pricing based on active residents, not beds. Perfect for family assessment centres tracking multiple family members per unit. Unlimited staff users included.",
  keywords:
    "family assessment centre pricing, residential assessment software cost, family assessment management pricing, residential care software pricing",
  author: "FamilyAxis",
  ogTitle: "Pricing - Family Assessment Centre Management Software | FamilyAxis",
  ogDescription:
    "Smart pricing based on active residents, not beds. Perfect for family assessment centres tracking multiple family members per unit. Unlimited staff users included.",
  ogUrl: "https://familyaxis.com/pricing",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Pricing - Family Assessment Centre Management Software | FamilyAxis",
  twitterDescription:
    "Smart pricing based on active residents, not beds. Perfect for family assessment centres tracking multiple family members per unit.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

useHead({
  link: [{ rel: "canonical", href: "https://familyaxis.com/pricing" }],
});

// AI Addon Toggle
const aiEnabled = ref(true);

// Pricing Configuration
const pricingConfig = {
  currency: "£",
  tiers: {
    foundation: 300,
    growth: 400,
    horizon: 500, // Custom pricing
  },
  addons: {
    ai: 59,
  },
};

const tiers = [
  {
    id: "foundation",
    title: "Foundation",
    price: `${pricingConfig.currency}${pricingConfig.tiers.foundation}`,
    description: "Perfect for smaller centres (up to 11 residents)",
    billingCycle: "/month (excl. VAT)",
    button: { label: "Get Started", disabled: false, to: "/signup" },
    highlight: true,
    badge: { label: "Most Popular" },
  },
  {
    id: "growth",
    title: "Growth",
    price: `${pricingConfig.currency}${pricingConfig.tiers.growth}`,
    description: "Ideal for growing centres (up to 18 residents)",
    billingCycle: "/month (excl. VAT)",
    button: { label: "Get Started", disabled: false, to: "/signup" },
  },
  {
    id: "horizon",
    title: "Horizon",
    price: "500",
    description: "For large operations (25 residents)",
    billingCycle: "/month (excl. VAT)",
    button: { label: "Get Started", disabled: false, to: "/signup" },
    // button: {
    //   label: "Contact Sales",
    //   color: "neutral" as const,
    //   disabled: false,
    //   to: "/contact-sale",
    // },
  },
];

const sections = [
  {
    id: "core",
    title: "Core Features",
    subtitle: "Essential tools for every assessment centre",
    icon: "i-heroicons-heart",
    features: [
      {
        id: "users",
        title: "Staff Users",
        tiers: {
          foundation: "Unlimited",
          growth: "Unlimited",
          horizon: "Unlimited",
        },
      },
      {
        id: "residents",
        title: "Max Active Residents",
        tiers: { foundation: "11", growth: "18", horizon: "25" },
      },
      {
        id: "cancel",
        title: "14-day Free Trial",
        tiers: { foundation: true, growth: true, horizon: true },
      },
      // {
      //   id: "residential",
      //   title: "Centre management",
      //   tiers: { foundation: true, growth: true, horizon: true },
      // },
      // {
      //   id: "observations",
      //   title: "Powerful observation logging",
      //   tiers: { foundation: true, growth: true, horizon: true },
      // },
      {
        id: "obs_dw",
        title: "Observation logging & Direct work tracking",
        tiers: { foundation: true, growth: true, horizon: true },
      },
      {
        id: "family_tracking",
        title: "Parent & Child Profiles",
        tiers: { foundation: true, growth: true, horizon: true },
      },
      {
        id: "safeguarding",
        title: "Safeguarding & Alerts",
        tiers: { foundation: true, growth: true, horizon: true },
      },
    ],
  },
  {
    id: "management",
    title: "Management Tools",
    subtitle: "Advanced management & collaboration",
    icon: "i-heroicons-chart-bar",
    features: [
      //   {
      //     title: 'Mobile App Access',
      //     tiers: { foundation: true, growth: true, horizon: true }
      //   },
      // {
      //   title: "Centralised Dashboard",
      //   tiers: { foundation: true, growth: true, horizon: true },
      // },
      {
        title: "Tasks Management & Planner",
        tiers: { foundation: true, growth: true, horizon: true },
      },
      {
        title: "Custom Alerts & Notifications",
        tiers: { foundation: true, growth: true, horizon: true },
      },

      {
        title: "Advanced Reporting & Export",
        tiers: { foundation: true, growth: true, horizon: true },
      },

      {
        title: " Staff Dashboard - HR Management Toolset",
        tiers: { foundation: true, growth: true, horizon: true },
      },

      // {
      //   title: "Gantt Timeline View",
      //   tiers: { foundation: false, growth: false, horizon: true },
      // },
    ],
  },
  {
    id: "aipowered",
    title: "FamilyAxis AI - Compass",
    features: [
      {
        id: "grammarcheck",
        title: "Grammar Check & Writing Helper",
        tiers: { foundation: true, growth: true, horizon: true },
      },
      {
        id: "catchupresume",
        title: "Catchup Resume for Staff Members",
        tiers: { foundation: true, growth: true, horizon: true },
      },
      {
        id: "aichat",
        title: "Analyse & Chat with your Data",
        tiers: { foundation: "SOON", growth: "SOON", horizon: "SOON" },
      },
    ],
  },
  {
    id: "onboarding",
    title: "Onboarding & Support",
    subtitle: "Get the most out of FamilyAxis",
    icon: "i-heroicons-light-bulb",
    features: [
      {
        id: "videolibrary",
        title: "Pre-recorded Video Library",
        tiers: { foundation: "SOON", growth: "SOON", horizon: "SOON" },
      },
      {
        id: "managertraining",
        title: "Manager-Specific Training",
        tiers: { foundation: true, growth: true, horizon: true },
      },
      {
        id: "initialonboarding",
        title: "Initial Group Onboarding Session",
        tiers: { foundation: "Custom", growth: "Custom", horizon: "Custom" },
      },
      {
        id: "support",
        title: "Support",
        tiers: {
          foundation: "Email / Help Desk",
          growth: "Email / Help Desk",
          horizon: true,
        },
      },
    ],
  },
];

// const showcaseFeatures = ref([
//   {
//     title: "Complete Family Assessment Platform",
//     description:
//       "Everything you need to manage residential family assessments in one comprehensive platform.",
//     icon: "i-heroicons-building-office",
//     image: "/images/dash_preview.webp",
//     link: "/more/centralised-dashboard",
//   },
//   {
//     title: "Streamlined Operations",
//     description:
//       "Reduce paperwork and administrative burden while maintaining compliance and quality.",
//     icon: "i-heroicons-clipboard-document-check",
//     image: "/images/obs_track.svg",
//     link: "/more/progress-observations",
//   },
// ]);

// Dynamic pricing based on AI addon
const dynamicTiers = computed(() => {
  return tiers.map((tier) => {
    if (tier.id === "foundation") {
      return {
        ...tier,
        price: `${pricingConfig.currency}${pricingConfig.tiers.foundation}`,
        badge: tier.badge,
      };
    } else if (tier.id === "growth") {
      return {
        ...tier,
        price: `${pricingConfig.currency}${pricingConfig.tiers.growth}`,
        // badge: aiEnabled.value ? { label: "Pro Features" } : undefined,
      };
    } else if (tier.id === "horizon") {
      return {
        ...tier,
        description: "For large operations (25+ residents) with special requirements",
      };
    }
    return tier;
  });
});

// Dynamic sections based on AI toggle
const dynamicSections = computed(() => {
  return sections.map((section) => {
    if (section.id === "aipowered") {
      return {
        ...section,
        features: aiEnabled.value ? section.features : [],
      };
    }
    return section;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_UPageHeader = _resolveComponent("UPageHeader")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UCard = _resolveComponent("UCard")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UBadge = _resolveComponent("UBadge")!
  const _component_UPricingTable = _resolveComponent("UPricingTable")!
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_ShowCaseCard = _resolveComponent("ShowCaseCard")!
  const _component_StartSignup = _resolveComponent("StartSignup")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, null, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHeader, {
            class: "pt-20 mx-10",
            title: "Transparent Pricing for Residential Family Centres",
            description: "Plans are based on active resident limits. Pick the tier that fits your caseload."
          }),
          _createVNode(_component_UPageBody, { class: "py-10 flex flex-col gap-10" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Motion), {
                as: "section",
                class: "px-6 sm:px-10 flex flex-col items-center justify-center text-center",
                initial: { opacity: 0, y: 20 },
                "while-in-view": { opacity: 1, y: 0 },
                viewport: { once: true },
                transition: { duration: 0.4, delay: 0.15 }
              }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-base text-gray-600 dark:text-gray-300 max-w-3xl" }, " Our pricing is built around how family assessment centres actually operate — clear, transparent tiers based on active residents, making it simple to budget and easy to manage as your service grows. ", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "mt-8 text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white" }, " All plans include: ", -1)),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_UCard, { class: "p-6 h-full transition-shadow hover:shadow-md border border-default/60" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-scale",
                              class: "size-5"
                            })
                          ]),
                          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-1" }, [
                            _createElementVNode("h3", { class: "text-base font-semibold" }, "Flexible Resident Limits"),
                            _createElementVNode("p", { class: "mt-1 text-sm text-gray-600 dark:text-gray-300" }, " Choose a plan with the right active resident cap and adjust as you grow. ")
                          ], -1))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_UCard, { class: "p-6 h-full transition-shadow hover:shadow-md border border-default/60" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-user-group",
                              class: "size-5"
                            })
                          ]),
                          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-1" }, [
                            _createElementVNode("h3", { class: "text-base font-semibold" }, "Unlimited Staff Accounts"),
                            _createElementVNode("p", { class: "mt-1 text-sm text-gray-600 dark:text-gray-300" }, " Add your entire team at no extra cost. ")
                          ], -1))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_UCard, { class: "p-6 h-full transition-shadow hover:shadow-md border border-default/60" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-clock",
                              class: "size-5"
                            })
                          ]),
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-1" }, [
                            _createElementVNode("h3", { class: "text-base font-semibold" }, "14-Day Free Trial"),
                            _createElementVNode("p", { class: "mt-1 text-sm text-gray-600 dark:text-gray-300" }, " Full platform access. Your first payment is only charged after the trial. ")
                          ], -1))
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(Motion), {
                as: "section",
                class: "px-6 sm:px-10",
                initial: { opacity: 0, y: 20 },
                "while-in-view": { opacity: 1, y: 0 },
                viewport: { once: true },
                transition: { duration: 0.4, delay: 0.2 }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UCard, {
                    class: "relative overflow-hidden border border-primary/20 dark:border-primary/30",
                    ui: {
              body: 'p-0',
              ring: '',
              shadow: 'shadow-lg shadow-primary/5 dark:shadow-primary/10',
            }
                  }, {
                    default: _withCtx(() => [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-primary/10 dark:bg-primary/20 rounded-full blur-3xl" }, null, -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute bottom-0 left-0 -mb-4 -ml-4 w-24 h-24 bg-emerald-500/10 dark:bg-emerald-500/20 rounded-full blur-2xl" }, null, -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-sparkles",
                              class: "size-4 text-emerald-600 dark:text-emerald-400"
                            }),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm font-medium text-emerald-700 dark:text-emerald-400" }, "Free Forever", -1))
                          ]),
                          _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3" }, " Try FamilyAxis at no cost ", -1)),
                          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-base text-gray-600 dark:text-gray-300 max-w-xl mb-6" }, " Get full access to every feature — observations, task management, family tracking, safeguarding, and reporting. No credit card required. Upgrade anytime as you grow. ", -1)),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-check-circle",
                                class: "size-5 text-primary"
                              }),
                              _cache[6] || (_cache[6] = _createElementVNode("span", null, [
                                _createTextVNode("Up to "),
                                _createElementVNode("strong", null, "3 active residents")
                              ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-check-circle",
                                class: "size-5 text-primary"
                              }),
                              _cache[7] || (_cache[7] = _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Unlimited"),
                                _createTextVNode(" staff users")
                              ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-check-circle",
                                class: "size-5 text-primary"
                              }),
                              _cache[8] || (_cache[8] = _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Full"),
                                _createTextVNode(" platform access")
                              ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-check-circle",
                                class: "size-5 text-primary"
                              }),
                              _cache[9] || (_cache[9] = _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "No"),
                                _createTextVNode(" credit card needed")
                              ], -1))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-center" }, [
                            _createElementVNode("div", { class: "text-4xl font-bold text-gray-900 dark:text-white" }, "Free"),
                            _createElementVNode("div", { class: "text-sm text-gray-500 dark:text-gray-400 mt-1" }, " forever, perfect to discover your new workflow. ")
                          ], -1)),
                          _createVNode(_component_UButton, {
                            label: "Start Free Trial",
                            color: "primary",
                            variant: "solid",
                            size: "lg",
                            icon: "i-heroicons-rocket-launch",
                            to: "/signup",
                            class: "w-full justify-center shadow-md shadow-primary/20 dark:shadow-primary/30"
                          }),
                          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 text-center" }, " 14-day trial included on all paid plans ", -1))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_UPricingTable, {
                  tiers: _unref(dynamicTiers),
                  sections: _unref(dynamicSections),
                  ui: {
              td: 'px-4 py-2 text-center border-b border-default',
              th: 'py-0 font-normal text-left border-b border-default',
              tier: 'p-4 text-left font-normal',
              item: 'p-4 flex flex-col border border-default rounded-lg',
              tierPriceWrapper: 'flex items-center gap-1 mt-2',
              tierButton: 'mt-4',
              sectionTitle: 'font-semibold text-sm text-highlighted p-0 m-0',
              feature: 'flex items-center justify-between gap-1 py-1',
              section: 'm-0 flex flex-col gap-1',
              thead: '*:pt-20',
            }
                }, {
                  "foundation-title": _withCtx(({ tier }) => [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_UIcon, {
                        name: "i-heroicons-star",
                        class: "size-4 text-amber-500"
                      }),
                      _createTextVNode(" " + _toDisplayString(tier.title), 1)
                    ])
                  ]),
                  "section-core-title": _withCtx(({ section }) => [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_UIcon, {
                        name: "i-heroicons-heart",
                        class: "size-6 text-pink-600 dark:text-pink-400"
                      }),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(section.title), 1),
                        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs text-pink-600 dark:text-pink-400" }, " Essential tools for every assessment centre ", -1))
                      ])
                    ])
                  ]),
                  "section-management-title": _withCtx(({ section }) => [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_UIcon, {
                        name: "i-heroicons-chart-bar",
                        class: "size-6 text-blue-600 dark:text-blue-400"
                      }),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(section.title), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-xs text-blue-600 dark:text-blue-400" }, " Advanced management & collaboration ", -1))
                      ])
                    ])
                  ]),
                  "section-onboarding-title": _withCtx(({ section }) => [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_UIcon, {
                        name: "i-heroicons-light-bulb",
                        class: "size-6 text-purple-600 dark:text-purple-400"
                      }),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(section.title), 1),
                        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs text-purple-600 dark:text-purple-400" }, " Get the most out of FamilyAxis ", -1))
                      ])
                    ])
                  ]),
                  "section-security-title": _withCtx(({ section }) => [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_UIcon, {
                        name: "i-lucide-shield-check",
                        class: "size-6 text-green-500"
                      }),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(section.title), 1)
                    ])
                  ]),
                  "section-aipowered-title": _withCtx(({ section }) => [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_UIcon, {
                          name: "i-heroicons-cpu-chip",
                          class: "size-6 text-purple-600 dark:text-purple-400"
                        }),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(section.title), 1)
                      ])
                    ])
                  ]),
                  "feature-users-value": _withCtx(({ feature, tier }) => [
                    _createVNode(_component_UBadge, {
                      label: String(feature.tiers?.[tier.id]),
                      color: "primary",
                      variant: "soft"
                    }, null, 8, ["label"])
                  ]),
                  "feature-residents-value": _withCtx(({ feature, tier }) => [
                    _createVNode(_component_UBadge, {
                      label: String(feature.tiers?.[tier.id]),
                      color: "orange",
                      variant: "soft"
                    }, null, 8, ["label"])
                  ]),
                  "feature-staffonboarding-value": _withCtx(({ feature, tier }) => [
                    _createVNode(_component_UBadge, {
                      label: String(feature.tiers?.[tier.id]),
                      color: "orange",
                      variant: "soft"
                    }, null, 8, ["label"])
                  ]),
                  "feature-reporthelper-value": _withCtx(({ feature, tier }) => [
                    (feature.tiers?.[tier.id] === 'SOON')
                      ? (_openBlock(), _createBlock(_component_UBadge, {
                          key: 0,
                          label: String(feature.tiers?.[tier.id]),
                          color: "black",
                          variant: "outline"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  "feature-videolibrary-value": _withCtx(({ feature, tier }) => [
                    (feature.tiers?.[tier.id] === 'SOON')
                      ? (_openBlock(), _createBlock(_component_UBadge, {
                          key: 0,
                          label: String(feature.tiers?.[tier.id]),
                          color: "black",
                          variant: "outline"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  "feature-aichat-value": _withCtx(({ feature, tier }) => [
                    (feature.tiers?.[tier.id] === 'SOON')
                      ? (_openBlock(), _createBlock(_component_UBadge, {
                          key: 0,
                          label: String(feature.tiers?.[tier.id]),
                          color: "black",
                          variant: "outline"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  "feature-grammarcheck-value": _withCtx(({ feature, tier }) => [
                    (feature.tiers?.[tier.id] === 'Trial')
                      ? (_openBlock(), _createBlock(_component_UBadge, {
                          key: 0,
                          label: String(feature.tiers?.[tier.id]),
                          color: "blue",
                          variant: "outline"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  "feature-catchupresume-value": _withCtx(({ feature, tier }) => [
                    (feature.tiers?.[tier.id] === 'Trial')
                      ? (_openBlock(), _createBlock(_component_UBadge, {
                          key: 0,
                          label: String(feature.tiers?.[tier.id]),
                          color: "blue",
                          variant: "outline"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  "feature-addresident-value": _withCtx(({ feature, tier }) => [
                    (feature.tiers?.[tier.id] === 'Trial')
                      ? (_openBlock(), _createBlock(_component_UBadge, {
                          key: 0,
                          label: String(feature.tiers?.[tier.id]),
                          color: "blue",
                          variant: "outline"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["tiers", "sections"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_UPageHero, {
                  title: "Complete Family Assessment Solution",
                  description: "Everything you need to manage residential family assessments effectively and efficiently.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
            }
                }),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_ShowCaseCard, {
                    title: "Centralised Dashboard",
                    description: "Manage all your operations from a single dashboard.",
                    icon: "i-heroicons-squares-2x2",
                    image: "/images/dash_preview.webp",
                    "image-position": "bottom",
                    link: "/more/centralised-dashboard",
                    class: "w-full md:w-4/7 h-110"
                  }),
                  _createVNode(_component_ShowCaseCard, {
                    title: "Seamless Collaboration",
                    description: "Enable your team to work together efficiently with built-in collaboration tools.",
                    icon: "i-heroicons-user-group",
                    image: "/images/tasks_preview.svg",
                    "image-position": "right",
                    link: "/more/team-collaboration",
                    class: "w-full md:w-3/7 h-110"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_UPageHero, {
                  title: "Focus on What Matters Most",
                  description: "Spend less time on paperwork and more time supporting families with our streamlined tools.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
            }
                }),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_ShowCaseCard, {
                    title: "Family Engagement",
                    description: "Tools for life story work and parent profiles to ensure the family's voice is always heard.",
                    icon: "i-heroicons-heart",
                    image: "/more/story.webp",
                    "image-position": "cover",
                    link: "/more/family-engagement",
                    reverse: "true",
                    class: "w-full md:w-3/7 h-110"
                  }),
                  _createVNode(_component_ShowCaseCard, {
                    title: "Progress Tracking",
                    description: "Monitor progress with detailed observations and visual insights that tell the complete story.",
                    icon: "i-heroicons-chart-bar",
                    image: "/images/obs_track.svg",
                    "image-position": "bottom",
                    link: "/more/progress-observations",
                    class: "w-full md:w-4/7 h-110"
                  })
                ])
              ]),
              _createVNode(_component_StartSignup),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_UCard, { class: "max-w-full mx-auto text-center bg-gradient-to-br from-green-50 to-emerald-100 dark:from-green-950/30 dark:to-emerald-950/30 border border-green-200 dark:border-green-800" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_UIcon, {
                            name: "i-heroicons-heart",
                            class: "h-8 w-8 text-green-600 dark:text-green-400"
                          })
                        ]),
                        _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-2xl font-bold text-gray-900 dark:text-white mb-2" }, " A Charity or Non-Profit? ", -1)),
                        _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-300 mb-6" }, " We are committed to supporting charities and non-profits working with vulnerable families. ", -1))
                      ]),
                      _createVNode(_component_UButton, {
                        label: "Contact us for special pricing",
                        color: "success",
                        variant: "solid",
                        size: "lg",
                        icon: "i-heroicons-phone",
                        to: "/about/#contact"
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})